import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import { FullWidthImage } from "@learningblocks/protocol-components";
import { PlainText } from "@learningblocks/storybook-components";
import { AnswerChoice } from "./AnswerChoice";
import { AnswerStep } from "./AnswerStep";
import { Slider } from "./Slider";
import { ResponseArea } from "./ResponseArea";
import { NumericEntry } from "./NumericEntry";
import { QuestionFooter } from "@learningblocks/protocol-components";
import { QUESTION_CONTENTS } from "@learningblocks/protocol-constants/lib/Utilities";
import { TypedOption } from "./TypedOption";
import { SliderGroup } from "./SliderGroup";
import "./style.scss";
import { NO_WRONG_ANSWER } from "@learningblocks/protocol-constants/lib/Utilities";

import { HighlightHTML } from "@learningblocks/storybook-components";
import { Log } from "@learningblocks/shared-components";

const CLASSNAMES = {
  CORRECT: "correct",
  INCORRECT: "incorrect",
};

export class QuestionCSCQ extends React.Component {
  renderMCQFeedback = () => {
    let passedCrit;
    const selectedOptions = this.props.checkboxes.map((option) => {
      if (option.selected && option.disabled) {
        return option.id;
      }
    });

    this.props.feedback.every((item) => {
      const passCriteria = [];

      item.criteria.forEach((crit) => {
        if (crit.includes("-")) {
          passCriteria.push(!selectedOptions.includes(-parseInt(crit, 10)));
        } else {
          passCriteria.push(selectedOptions.includes(parseInt(crit, 10)));
        }
      });

      if (passCriteria.every((pass) => pass === true)) {
        passedCrit = item;
        return false;
      } else {
        return true;
      }
    });

    if (
      passedCrit &&
      this.props.checkboxes.some((option) => option.selected && option.disabled)
    ) {
      return (
        <p
          className={
            selectedOptions.every((id) => {
              return this.props.answerId.includes(id) || id == null;
            })
              ? CLASSNAMES.CORRECT
              : CLASSNAMES.INCORRECT
          }
        >
          {parse(passedCrit.feedback)}
        </p>
      );
    } else {
      return null;
    }
  };

  renderGroupedSCSQFeedback = () => {
    let passedCrit;
    const selectedOptions = this.props.lastSubmission;
    //let key = Object.keys(this.props.interactionProps.solutions[14].solutions)[0];
    const key = this.getKey();

    //alert("SELECTED OPTIONS:" + JSON.stringify(this.props.lastSubmission))

    if (typeof selectedOptions !== "undefined") {
      this.props.feedback[key].every((item) => {
        const passCriteria = [];

        item.criteria.forEach((crit, critIndex) => {
          if (item.criteria.length === selectedOptions.length) {
            if (crit.includes("-")) {
              passCriteria.push(
                parseInt(crit, 10) !== selectedOptions[critIndex]
              );
            } else {
              passCriteria.push(
                parseInt(crit, 10) === selectedOptions[critIndex]
              );
            }
          } else {
            passCriteria.push(false);
          }
        });

        if (passCriteria.every((pass) => pass === true)) {
          passedCrit = item;
          return false;
        } else {
          return true;
        }
      });

      if (passedCrit) {
        //alert("PASSED CRIT:" + JSON.stringify(passedCrit.criteria))
        return (
          <p
            className={
              selectedOptions.every((id, index) => {
                if (selectedOptions.length > 1) {
                  return this.props.answerId[key][index] == id;
                } else {
                  return this.props.answerId[key].includes(id);
                }
              })
                ? CLASSNAMES.CORRECT
                : CLASSNAMES.INCORRECT
            }
          >
            {parse(passedCrit.feedback)}
          </p>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  renderByType = (type, key) => {
    switch (type) {
      case QUESTION_CONTENTS.QUESTION:
        return this.question(key);
      case QUESTION_CONTENTS.QUESTION1:
        return this.question1(key);
      case QUESTION_CONTENTS.QUESTION2:
        return this.question2(key);
      case QUESTION_CONTENTS.TEXT:
        return this.text(key);
      case QUESTION_CONTENTS.IMAGE:
        return this.image(key);
      case QUESTION_CONTENTS.FIG_CAPTION:
        return this.figcaption(key);
      case QUESTION_CONTENTS.OPTIONS:
        return this.options(key);
      case QUESTION_CONTENTS.GROUPED_OPTIONS1:
        return this.options1(key);
      case QUESTION_CONTENTS.GROUPED_OPTIONS2:
        return this.options2(key);
      case QUESTION_CONTENTS.ANSWER_STEPS:
        return this.answerStepsDDQ(key);
      case QUESTION_CONTENTS.SLIDERS:
        return this.slidersDNDQ(key);
      case QUESTION_CONTENTS.TYPED_OPTIONS:
        return this.typedOption(key);
      case QUESTION_CONTENTS.SLIDER_GROUPS:
        return this.sliderGroups(key);
      case QUESTION_CONTENTS.CHECKBOXES:
        return this.checkboxList(key);
      case QUESTION_CONTENTS.RESPONSE_AREA:
        return this.responseArea(key);
      case QUESTION_CONTENTS.NUMERIC_ENTRY:
        return this.numericEntry(key);
      default:
        return null;
    }
  };

  renderContent = () => {
    return this.props.content.map(this.renderByType);
  };

  question = (key) => {
    return (
      <HighlightHTML
        key={key}
        className={`${this.props.className}__text`}
        content={this.props.question}
        getContentData={this.props.getContentData}
        openGlossary={this.props.openGlossary}
      />
    );
  };

  question1 = (key) => {
    return (
      <PlainText
        key={key}
        className={`${this.props.className}__text`}
        text={this.props.question1}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
      />
    );
  };

  question2 = (key) => {
    return (
      <PlainText
        key={key}
        className={`${this.props.className}__text`}
        text={this.props.question2}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
      />
    );
  };

  text = (key) => {
    return (
      <PlainText
        key={key}
        className={`${this.props.className}__text`}
        text={this.props.text}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
      />
    );
  };

  figcaption = (key) => {
    return (
      <FullWidthImage
        key={key}
        className={`${this.props.className}__image`}
        image={this.props.figcaption.image}
        caption={this.props.figcaption.caption}
        altText={this.props.figcaption.altText}
        getGlossaryItem={this.props.getGlossaryItem}
        openGlossary={this.props.openGlossary}
      />
    );
  };

  image = (key) => {
    return (
      <FullWidthImage
        key={key}
        className={`${this.props.className}__image`}
        image={this.props.image}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
        altText={this.props.altText}
      />
    );
  };

  options = (contentKey) => {
    return this.props.options.map((option, optionKey) => (
      <AnswerChoice
        complete={this.props.complete}
        selectOption={this.props.selectOption}
        key={`${contentKey}_${optionKey}`}
        className={`${this.props.className}__option`}
        componentID={this.props.id}
        componentType={this.props.type}
        answerId={this.props.answerId}
        // isCorrect={this.props.answerId === option.id}
        isCorrect={this.isCorrect(this.props.answerId, option.id)}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
        {...option}
      />
    ));
  };

  isCorrect = (answerId, optionId) => {
    if (answerId === NO_WRONG_ANSWER) return true;
    return answerId === optionId;
  };

  hasSample(lanes, sample) {
    for (const lane in lanes) {
      if (lanes[lane].solutionAlias === sample) {
        return true;
      }
    }
    return false;
  }

  getKey() {
    let key;
    const lanes = this.props.interactionProps.agaroseGel[0].lanes;
    const hasSample = this.hasSample(lanes, "Gel sample 1: unknown");
    if (hasSample) {
      const randomDna = Object.keys(
        this.props.interactionProps.solutions[5].solutions
      )[0];
      key = randomDna;
    } else {
      key = "NONE";
    }
    return key;
  }
  options1 = (contentKey) => {
    //let key = Object.keys(this.props.interactionProps.solutions[14].solutions)[0];
    const key = this.getKey();
    return this.props.groupedOptions1.map((option, optionKey) => (
      <AnswerChoice
        complete={this.props.complete}
        selectOption={this.props.selectOption}
        optionGroup={1}
        key={`${contentKey}_${optionKey}`}
        answerKey={key}
        className={`${this.props.className}__option`}
        componentID={this.props.id}
        componentType={this.props.type}
        isCorrect={this.props.answerId[key][0] === option.id}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
        {...option}
      />
    ));
  };

  options2 = (contentKey) => {
    //let key = Object.keys(this.props.interactionProps.solutions[14].solutions)[0];
    const key = this.getKey();
    //alert(key)
    const options = this.props.groupedOptions2.map((option, optionKey) => (
      <AnswerChoice
        complete={this.props.complete}
        selectOption={this.props.selectOption}
        optionGroup={2}
        key={`${contentKey}_${optionKey}`}
        answerKey={key}
        className={`${this.props.className}__option`}
        componentID={this.props.id}
        componentType={this.props.type}
        isCorrect={this.props.answerId[key][1] === option.id}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
        {...option}
      />
    ));

    return (
      <>
        {options}
        {this.renderGroupedSCSQFeedback()}
      </>
    );
  };

  checkboxList = (contentKey) => {
    const options = this.props.checkboxes.map((option, optionKey) => (
      <AnswerChoice
        complete={this.props.complete}
        selectCheckbox={this.props.selectCheckbox}
        key={`${contentKey}_${optionKey}`}
        className={`${this.props.className}__option`}
        componentID={this.props.id}
        componentType={this.props.type}
        isCorrect={this.props.answerId.includes(option.id)}
        getGlossaryItem={this.props.getGlossaryItem}
        onOpenGlossary={this.props.openGlossary}
        {...option}
      />
    ));

    return (
      <>
        {options}
        {this.renderMCQFeedback()}
      </>
    );
  };

  responseArea = (key) => {
    return (
      <ResponseArea
        key={key}
        className={`${this.props.className}__response_area`}
        componentID={this.props.id}
        componentType={this.props.type}
        feedback={this.props.feedback}
        feedbackIcon={this.props.feedbackIcon}
        responseOEQChange={this.props.responseOEQChange}
        savedResponse={this.props.savedResponse}
      />
    );
  };

  numericEntry = (key) => {
    return (
      <NumericEntry
        key={key}
        className={`${this.props.className}__response_area`}
        componentID={this.props.id}
        componentType={this.props.type}
        responseNEQChange={this.props.responseNEQChange}
        numericEntry={this.props.numericEntry}
        savedEntry={this.props.savedEntry}
        feedback={this.props.feedback}
        isCorrect={
          parseFloat(this.props.savedEntry, 10) >= this.props.answerId[0] &&
          parseFloat(this.props.savedEntry, 10) <= this.props.answerId[1]
        }
      />
    );
  };

  answerStepsDDQ = (contentKey) => {
    return this.props.answerSteps.map((answer, optionKey) => (
      <AnswerStep
        disabled={this.props.complete}
        key={`${contentKey}_${optionKey}`}
        allOptions={this.props.options}
        componentID={this.props.id}
        {...answer}
        placeholder={this.props.optionPlaceholder}
      />
    ));
  };

  slidersDNDQ = (contentKey) => {
    return this.props.sliders.map((slider, optionKey) => (
      <Slider
        label={optionKey + 1}
        componentID={this.props.id}
        key={`${contentKey}_${optionKey}`}
        {...slider}
      />
    ));
  };

  sliderGroups = (contentKey) => {
    return this.props.sliderGroups.map((group, groupKey) => (
      <SliderGroup
        key={`${contentKey}_${groupKey}`}
        componentID={this.props.id}
        {...group}
        label={groupKey + 1}
      />
    ));
  };

  typedOption = (contentKey) => {
    return this.props.typedOptions.map((option, optionKey) => (
      <TypedOption
        selectOption={this.props.selectOption}
        key={`${contentKey}_${optionKey}`}
        className={`${this.props.className}__option`}
        componentID={this.props.id}
        isCorrect={this.props.answerId === option.id}
        {...option}
      />
    ));
  };

  getQuestionType = () => {
    let callout;

    switch (this.props.type) {
      case "GROUPED_CSCQ":
        callout = "Grouped Single-choice Question";
        break;
      case "CSCQ":
        callout = "Single-choice Question";
        break;
      case "MSCQ":
        callout = "Multiple-choice Question";
        break;
      case "OEQ":
        callout = "Open-ended Question";
        break;
      case "NEQ":
        callout = "Numeric-entry Question";
        break;
      default:
      // code block
    }

    return callout;
  };

  render() {
    // const { question, options, level, section, collectResponse } = this.props;
    return (
      <div className={this.props.className}>
        <Log question_number={this.props.id}>
          <p
            style={{
              margin: "8px 0 8px 0",
              fontSize: "14px",
              fontWeight: 600,
              textTransform: "uppercase",
            }}
          >
            {this.getQuestionType()}
          </p>
          {this.renderContent()}
          <QuestionFooter
            className={`${this.props.className}__footer`}
            complete={this.props.complete}
            type={this.props.type}
            options={this.props.options}
            groupedOptions1={this.props.groupedOptions1}
            groupedOptions2={this.props.groupedOptions2}
            answerId={this.props.answerId}
            typedOptions={this.props.typedOptions}
            responseArea={this.props.responseArea}
            savedResponse={this.props.savedResponse}
            numericEntry={this.props.numericEntry}
            savedEntry={this.props.savedEntry}
            answerSteps={this.props.answerSteps}
            sliders={this.props.sliders}
            sliderGroups={this.props.sliderGroups}
            totalAttempts={this.props.totalAttempts}
            checkboxes={this.props.checkboxes}
            id={this.props.id}
            showFeedback={this.props.showFeedback}
          />
        </Log>
      </div>
    );
  }
}
QuestionCSCQ.propTypes = {
  answerId: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  answer: PropTypes.array || PropTypes.any,
  optionPlaceholder: PropTypes.string || PropTypes.any,
  complete: PropTypes.bool,
  content: PropTypes.array,
  id: PropTypes.number,
  image: PropTypes.string,
  options: PropTypes.array,
  question: PropTypes.string,
  totalAttempts: PropTypes.number,
  type: PropTypes.string,
  submitAnswer: PropTypes.func,
  className: PropTypes.string,
  answerSteps: PropTypes.array || PropTypes.any,
  sliders: PropTypes.array || PropTypes.any,
  sliderGroups: PropTypes.array || PropTypes.any,
  showFeedback: PropTypes.bool || PropTypes.any,
};

QuestionCSCQ.defaultProps = {
  className: "question",
};
